import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const ChadFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16084'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16084)'>
				<rect
					x='9.52344'
					width='10.4762'
					height='14'
					fill='#DE1D42'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H6.66667V0H0V14Z'
					fill='#083780'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 14H13.3327V0H6.66602V14Z'
					fill='#FFD147'
				/>
			</g>
		</svg>
	);
};

export default ChadFlagIcon;
